import React from "react";
import Button from "../Common/FormElements/Button/Button";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeCenteredModal } from "../../REDUX/actions/centeredModal";

const ValidateDelivery = ({ handleClick }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  return (
    <div className="d-flex flex-column gap-3 justify-content-center transporter-select max-w-500px mx-auto">
      <div className="d-flex flex-column gap-2">
        <span className="f16 text-dark text-center mb-3">
          {t(
            "By clicking Confirm, you agree to take responsibility for completing the delivery on the indicated date. This validation is binding and cannot be cancelled."
          )}
        </span>
      </div>
      <div className="d-flex gap-3 align-items-center justify-content-center">
        <Button onClick={handleClick}>{t("Validate")}</Button>
        <Button
          type="button"
          variant="outline"
          onClick={() => dispatch(closeCenteredModal())}
        >
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default ValidateDelivery;
